export function encrypt(text: string): string {
    return btoa(text);
}

export function decrypt(text: string): string {
    return atob(text);
}